import { Controller } from "stimulus";
import centreInScroller from "./centre_in_scroller";

const fold = (text) => text.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();

// Filters the podcast tiles by title as the viewer types, and opens scrolled to the picked one.
export default class PodcastSheetController extends Controller {
  static targets = ["input", "clear", "grid", "tile", "empty", "term"];

  connect() {
    this.filter();
    this.centreActive();
    if (window.matchMedia("(min-width: 768px)").matches) this.focusInput();
  }

  filter() {
    const query = fold(this.inputTarget.value.trim());
    let shown = 0;

    this.tileTargets.forEach((tile) => {
      const match = query ? !("all" in tile.dataset) && fold(tile.dataset.title).includes(query) : true;
      tile.hidden = !match;
      if (match) shown += 1;
    });

    this.clearTarget.hidden = !query;
    this.gridTarget.hidden = shown === 0;
    this.emptyTarget.hidden = shown > 0;
    this.termTarget.textContent = this.inputTarget.value.trim();
  }

  clear() {
    this.inputTarget.value = "";
    this.filter();
    this.focusInput();
  }

  focusInput() {
    const input = this.inputTarget;
    input.focus({ preventScroll: true });
    input.setSelectionRange(input.value.length, input.value.length);
  }

  centreActive() {
    const active = this.gridTarget.querySelector('[aria-current="true"]:not([hidden])');
    if (active) centreInScroller(this.gridTarget, active, "y");
  }
}
